import React from "react";
import "./Footer.css";
import { greeting } from "../../shared/constants";

import { Fade } from "react-awesome-reveal";

export default function Footer(props: { theme: { secondaryText: any } }) {
  return (
    <div className="footer-div">
      <Fade triggerOnce={true}>
        <p className="footer-text" style={{ color: props.theme.secondaryText }}>
          DESIGNED BY <span role="img"></span> CODING COGS TEAMS
        </p>
      </Fade>
    </div>
  );
}
